// 环境配置
const config = {
  // API地址
  apiUrl: process.env.VUE_APP_API_URL || 'http://8.153.206.61:3002/',
  
  // 判断当前环境
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production',
  
  // 环境名称
  env: process.env.NODE_ENV
};

export default config; 